import MarkerClusterer from '@googlemaps/markerclustererplus';
import {
  DrawPoligonsPayload,
  IFlowPoints,
  IMapsMouseEvent,
  IMarkMultiplesOnMapWithInfoWindowPayload,
  IMarkMultiplesOnMapWithoutClusterPayload,
} from './map.types';

export const updateClusterValue = (
  calculateClusterPriceAvrage: (cluster: MarkerClusterer) => void,
  // Property 'clusterIcon_' is private and only accessible within class 'Cluster'.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  clusters: any[]
) => {
  const elements = document.getElementsByClassName('cluster cluster-0');

  if (clusters.length > 0 && elements.length > 0) {
    clusters.forEach((cluster) => {
      // eslint-disable-next-line no-underscore-dangle
      const childrens = cluster.clusterIcon_.div_.children;
      if (childrens.length > 0) {
        childrens[1].children[0].textContent =
          calculateClusterPriceAvrage(cluster);
      }
    });
  }
};

export const polygonAddOn = (
  poly: google.maps.Polygon,
  payload: DrawPoligonsPayload,
  MapPEAPoligons: google.maps.Polygon[][],
  MapIncomePoligons: google.maps.Polygon[][]
) => {
  // eslint-disable-next-line no-case-declarations
  let poligons: google.maps.Polygon[][] = [];

  if (payload.type === 'pea') poligons = MapPEAPoligons;
  if (payload.type === 'income') poligons = MapIncomePoligons;

  if (
    (payload.checkboxId || payload.checkboxId === 0) &&
    poligons[payload.checkboxId] === undefined
  ) {
    poligons[payload.checkboxId] = [];
  }
  if (payload.checkboxId || payload.checkboxId === 0) {
    poligons[payload.checkboxId].push(poly);
  }
};

export const flowPointAttatcher = (
  payload: IMarkMultiplesOnMapWithoutClusterPayload,
  marker: google.maps.Marker,
  MapFlowPoints: IFlowPoints[]
): IFlowPoints[] => {
  const flwPnt = MapFlowPoints?.find(
    (flowPoint: IFlowPoints) => flowPoint.type === payload.flowPointsType
  );

  if (!flwPnt)
    MapFlowPoints.push({ type: payload.flowPointsType as string, markers: [] });

  return MapFlowPoints?.map((flowPoint: IFlowPoints) => {
    if (flowPoint.type === payload.flowPointsType) {
      flowPoint.markers.push(marker);
    }

    return flowPoint;
  });
};

export const attatcher = (
  payload: IMarkMultiplesOnMapWithInfoWindowPayload,
  marker: google.maps.Marker,
  points: IFlowPoints[]
): IFlowPoints[] => {
  const pnt = points?.find((point: IFlowPoints) => point.type === payload.type);

  if (!pnt) points.push({ type: payload.type as string, markers: [] });

  return points?.map((point: IFlowPoints) => {
    if (point.type === payload.type) {
      point.markers.push(marker);
    }

    return point;
  });
};

export const controlEventListinerOnMarker = (
  map: google.maps.Map,
  marker: google.maps.Marker,
  infoWindow: google.maps.InfoWindow,
  infoWindows: google.maps.InfoWindow[]
) => {
  marker.addListener('click', () => {
    infoWindows.forEach((iw) => {
      iw.close();
    });
    infoWindow.open({
      anchor: marker,
      map,
      shouldFocus: false,
    });
  });

  marker.addListener('mouseover', () => {
    infoWindow.open({
      anchor: marker,
      map,
      shouldFocus: false,
    });
  });

  let closeInfoWindowWithTimeout: NodeJS.Timeout;
  marker.addListener('mouseout', () => {
    closeInfoWindowWithTimeout = setTimeout(() => infoWindow.close(), 200);
    document
      .getElementsByClassName('ContainerCardSchool')[0]
      .addEventListener('mouseover', () =>
        clearTimeout(closeInfoWindowWithTimeout)
      );
  });

  infoWindow.addListener('domready', () => {
    const infowindowelement = document.getElementsByClassName(
      'ContainerCardSchool'
    )[0];
    const booleanInfowindow = !!infowindowelement;
    if (booleanInfowindow)
      infowindowelement.parentElement?.parentElement?.parentElement?.addEventListener(
        'mouseleave',
        () => infoWindow.close()
      );
  });
};

export const controlEventListinerDrawPoligons = (
  map: google.maps.Map,
  infoWindows: google.maps.InfoWindow[],
  classCloseInfoWindow: string,
  infoWindow: google.maps.InfoWindow,
  poly: google.maps.Polygon
) => {
  poly.addListener('click', (mapsMouseEvent: IMapsMouseEvent) => {
    infoWindows.forEach((iw) => {
      iw.close();
    });
    infoWindow.setPosition(mapsMouseEvent.latLng);
    infoWindow.open({
      map,
      shouldFocus: false,
    });
    setTimeout(() => {
      if (classCloseInfoWindow) {
        const closeComponent =
          document.getElementsByClassName(classCloseInfoWindow)[0];
        closeComponent.addEventListener('click', () => infoWindow.close());
      }
    }, 100);
  });
};

export const appendInfoWindowToMarker = (
  map: google.maps.Map,
  marker: google.maps.Marker,
  infoWindow: google.maps.InfoWindow,
  infoWindows: google.maps.InfoWindow[],
) => {
  marker.addListener('click', () => {
    infoWindows.forEach((iw) => {
      iw.close();
    });
    infoWindow.open({
      anchor: marker,
      map,
      shouldFocus: false,
    });
  });
};

export const controlEventListinerMouseOverPolygon = (
  map: google.maps.Map,
  infoWindows: google.maps.InfoWindow[],
  infoWindow: google.maps.InfoWindow,
  poly: google.maps.Polygon
) => {
  const bounds = new google.maps.LatLngBounds();
  poly.getPath().forEach(function (element, index) {
    bounds.extend(element);
  });
  const polyCenter = bounds.getCenter();
  poly.addListener('mouseover', () => {
    infoWindows.forEach((iw) => {
      iw.close();
    });
    infoWindow.setPosition(polyCenter);
    infoWindow.open({
      map,
      shouldFocus: false,
    });
  });
};

export const createInfoWindow = (
  map: google.maps.Map,
  infoWindows: google.maps.InfoWindow[],
  payload: DrawPoligonsPayload,
  poly: google.maps.Polygon
) => {
  if (!payload.infoWindow) {
    poly.addListener('click', () => payload.onClick(poly));
    return;
  }

  const infoWindow = new google.maps.InfoWindow({
    content: payload.infoWindow,
  });
  infoWindows.push(infoWindow);

  if (!payload.classCloseInfoWindow) {
    controlEventListinerMouseOverPolygon(map, infoWindows, infoWindow, poly);
    poly.addListener('click', () => payload.onClick(poly));
    return;
  }

  controlEventListinerDrawPoligons(
    map,
    infoWindows,
    payload.classCloseInfoWindow,
    infoWindow,
    poly
  );
};
